const actions = {
  SET_STATE: 'season/SET_STATE',
  REFRESH_ERRORS: 'season/REFRESH_ERRORS',
  ACTIVE: 'season/ACTIVE'
};

export default actions
